import React from 'react';

const Meter = function (props) {
	const {
    percent = 0,         // number: 0 - 1, inclusive. Fill %
    width = 80,         // the width of our meter
    height = 12,         // the height of our meter
    rounded = false,      // if true, use rounded corners
    color = 'var(--green)',   // the fill color
    animate = false,     // if true, animate
    label = null         // a label for accessibility
  } = props;
		
  const r = rounded ? Math.ceil(height / 2) : 0;
  const w = percent ? Math.max(height/10, width * Math.min(percent, 1)) : height/10;
  const style = animate ? { "transition": "width 500ms, fill 250ms" } : null;

return (
  <svg width={width} height={height} aria-label={label}>
    <rect width={width} height={height} fill="#ccc" rx={r} ry={r}/>
    <rect width={w} height={height} fill={color} rx={r} ry={r}   style={style}/>
  </svg>
);

}
export default Meter;


// WEBPACK FOOTER //
// ./src/Meter.js


// WEBPACK FOOTER //
// ./src/Meter.js